module.exports = __webpack_public_path__ + "static/media/waterTank2.d03d5afa.jpg";